import '@scripts/frontend/animation/homepage-hero-galaxy';
import '@scripts/frontend/animation/feature-showcase-animation';
import '@styles/frontend/main.scss';
import FeatureShowcaseCard from './feature-showcase-card';
import Menu from './menu.js';
import FlippingMediaAccordion from './flipping-media-accordion';
import ColorMediaColumns from "./colored-media-columns";
import HomepageHeroAnimation from "./animation/homepage-hero-animation";
import TypingScrollAnimation from "./animation/typing-scroll-animation";
import BrandmarkHover from "./animation/brandmark-hover";
import DynamicVideos from './dynamic-videos'
import '@scripts/frontend/insights/insights-listing'
import InsightsTOC from './insights/toc'
import PlayOnHover from './play-on-hover'
import AnimatedCards from './animated-cards'
import PracticeAreaList from './practice-area-list'
import { initializeAlert } from './alert-banner';
import './lead-form-button';


document.addEventListener('DOMContentLoaded', () => {
  initializeAlert();
  Menu();
  DynamicVideos();
  FeatureShowcaseCard();
  ColorMediaColumns();
  FlippingMediaAccordion();
  HomepageHeroAnimation();
  TypingScrollAnimation();
  BrandmarkHover();
  InsightsTOC();
  PlayOnHover();
  AnimatedCards();
  PracticeAreaList();
})
